import React, { useState } from "react";

// Redux
import { Link, useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  FormFeedback,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import logo from "../../assets/images/logo/pappermap-logo-wordmark.png";
//import logoDark from "../../assets/images/logo/pappermap-logo-wordmark--dark 1.png";

import withRouter from "Components/Common/withRouter";
import { BaseButton, BaseInput } from "Components/ui";
import { createOrganization } from "services/auth.service";
import { toast } from "react-toastify";
import { handleAPIError } from "utils";

const SignUp = (props: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  //meta title
  document.title = "SignUp | Papermap";

  // Form validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      admin: {
        email: "",
        phone: "",
        address: "",
        name: "",
        password: "",
      },
      org: { name: "", address: "" },
    },
    validationSchema: Yup.object({
      admin: Yup.object({
        email: Yup.string()
          .email("Invalid email format")
          .required("Please Enter Your email"),
        phone: Yup.string(),
        address: Yup.string(),
        name: Yup.string().required("Please Enter your name"),
        password: Yup.string().required("Please Enter Your Password"),
      }),
      org: Yup.object({
        name: Yup.string().required("Please Enter Your organization name"),
        address: Yup.string(),
      }),
    }),
    onSubmit: (values: any) => {
      onSubmit(values);
    },
  });

  const onSubmit = async (data) => {
    // Handle form submission logic here
    setLoading(true);
    try {
      const result = await createOrganization({
        org: {
          name: data.org.name,
          address: data.org.address,
        },
        admin: {
          name: data.admin.name,
          email: data.admin.email,
          address: data.admin.address,
          phone: data.admin.phone,
          password: data.admin.password,
        },
      });
      toast.success("Account created successfully!");
      console.log("Sign up response: ", result);
      navigate("/login");
    } catch (error) {
      handleAPIError(error, true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Create a new account</h5>
                        <p>Get your Papermap account now.</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="auth-logo">
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                    <Link to="/" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-dark">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="54"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <BaseInput
                          name="admin.name"
                          label="Full name"
                          value={validation.values.admin.name || ""}
                          type="text"
                          placeholder="Enter full name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={Boolean(
                            validation.touched.admin?.name &&
                              validation.errors.admin?.name
                          )}
                          errorMessage={validation.errors.admin?.name}
                        />
                        {validation.touched.admin?.name &&
                        validation.errors.admin?.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.admin.name}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <BaseInput
                          name="admin.email"
                          placeholder="Enter email"
                          type="text"
                          label="Email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.admin.email || ""}
                          invalid={
                            validation.touched.admin?.email &&
                            validation.errors.admin?.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.admin?.email &&
                        validation.errors.admin?.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.admin.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <Row>
                        <Col md={6} className="mb-3">
                          <BaseInput
                            name="admin.phone"
                            placeholder="Enter your contact"
                            type="text"
                            label="Phone"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.admin.phone || ""}
                            invalid={Boolean(
                              validation.touched.admin?.phone &&
                                validation.errors.admin?.phone
                            )}
                            errorMessage={validation.errors.admin?.phone}
                          />
                          {validation.touched.admin?.phone &&
                          validation.errors.admin?.phone ? (
                            <FormFeedback type="invalid">
                              {validation.errors.admin.phone}
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <Col md={6} className="mb-3">
                          <BaseInput
                            name="admin.address"
                            label="Address"
                            value={validation.values.admin.address || ""}
                            type="text"
                            placeholder="Enter address"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={Boolean(
                              validation.touched.admin?.address &&
                                validation.errors.admin?.address
                            )}
                            errorMessage={validation.errors.admin?.address}
                          />
                          {validation.touched.admin?.address &&
                          validation.errors.admin?.address ? (
                            <FormFeedback type="invalid">
                              {validation.errors.admin.address}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} className="mb-3">
                          <BaseInput
                            name="org.name"
                            label="Organization"
                            value={validation.values.org.name || ""}
                            type="text"
                            placeholder="Enter organization name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={Boolean(
                              validation.touched.org?.name &&
                                validation.errors.org?.name
                            )}
                            errorMessage={validation.errors.org?.name}
                          />
                          {validation.touched.org?.name &&
                          validation.errors.org?.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.org.name}
                            </FormFeedback>
                          ) : null}
                        </Col>
                        <Col md={6} className="mb-3">
                          <BaseInput
                            name="org.address"
                            label="Organization Address"
                            value={validation.values.org.address || ""}
                            type="text"
                            placeholder="Enter organization address"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={Boolean(
                              validation.touched.org?.address &&
                                validation.errors.org?.address
                            )}
                            errorMessage={validation.errors.org?.address}
                          />
                          {validation.touched.org?.address &&
                          validation.errors.org?.address ? (
                            <FormFeedback type="invalid">
                              {validation.errors.org.address}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>

                      <div className="mb-3">
                        <BaseInput
                          name="admin.password"
                          label="Password"
                          value={validation.values.admin.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={Boolean(
                            validation.touched.admin?.password &&
                              validation.errors.admin?.password
                          )}
                          errorMessage={validation.errors.admin?.password}
                        />
                        {validation.touched.admin?.password &&
                        validation.errors.admin?.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.admin.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-4 d-grid">
                        <BaseButton
                          className="btn btn-primary btn-block "
                          type="submit"
                          loading={loading}
                          disabled={loading}
                        >
                          Register
                        </BaseButton>
                      </div>
                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          By registering you agree to the Papermap{" "}
                          <Link to="#" className="text-primary">
                            Terms of Use
                          </Link>
                        </p>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="fw-medium text-primary">
                    {" "}
                    Login{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(SignUp);
